import { render } from "./Webentity.vue?vue&type=template&id=930dddca"
import script from "./Webentity.vue?vue&type=script&lang=js"
export * from "./Webentity.vue?vue&type=script&lang=js"

import "./Webentity.vue?vue&type=style&index=0&id=930dddca&lang=sass"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__